export default __webpack_public_path__ + "static/media/flag_de.67ea3e1e.svg";